
export class InsuredTripListRequest {
  dateBegin: string;
  dateFrom: string;
  dateTo: string;
  statusId: string;
  personSurname: string;
  fromToChecked: boolean;
  policyNumberTravelMember: string;
  dateBirth: string;
  sortByPolicyNumber: boolean;
}
